import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { rootRoute } from './root'
import { RouteError } from '@lunary/ui-web/screen-state'

export const newReadingRoute = createRoute({
  path: 'readings/new',
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import('../features/readings/new-page'), 'NewReadingPage'),
  errorComponent: RouteError,
})
